import React from "react";
import { AlertTones } from "@origin-digital/ods-types";
import { ErrorTypeEnum } from "src/components/Form/types";
import { RemoveSupplyContext } from "./context";
import {
  DraftInfo,
  IRemoveSupplyContext,
  IRemoveSupplyProviderProps,
  SectionVisibility,
} from "./types";

export const RemoveSupplyProvider: React.FC<IRemoveSupplyProviderProps> = ({
  children,
}) => {
  const [displayingSnackbar, setDisplayingSnackbar] = React.useState<{
    message: string;
    tone: AlertTones;
  } | null>(null);
  const [premiseAddress, setPremiseAddress] = React.useState<string | null>(
    null
  );
  const [draftInfo, setDraftInfo] = React.useState<DraftInfo | null>(null);
  const [displayingAlertBanner, setDisplayingAlertBanner] =
    React.useState<ErrorTypeEnum | null>(null);
  const [activeSection, setActiveSection] =
    React.useState<string>("premiseSection");
  const [sectionVisibility, setSectionVisibility] =
    React.useState<SectionVisibility>({
      supportingDocumentsSection: false,
    });
  const contextValue: IRemoveSupplyContext = {
    displayingSnackbar,
    setDisplayingSnackbar,
    premiseAddress,
    setPremiseAddress,
    displayingAlertBanner,
    setDisplayingAlertBanner,
    draftInfo,
    setDraftInfo,
    activeSection,
    setActiveSection,
    sectionVisibility,
    setSectionVisibility,
  };

  return (
    <RemoveSupplyContext.Provider value={contextValue}>
      {children}
    </RemoveSupplyContext.Provider>
  );
};
